import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userTypePipe'
})
export class UserTypePipePipe implements PipeTransform {

  transform(value: any){
    if(value==0){return "Super Admin";}
    else if(value==1){return "Employee";}
    else if (value==2){return "Personal Driver"; }
    else if (value==3){return "Driver"; }
    else if (value==6){return "Cap Assists"; }
    else if (value==4){return "Driver Attendance Admin"; }
    else return "";
  }

}
